<template>
    <div class="container is-fluid">
        <div class="columns">
            <div class="column">
                <div class="buttons mb-15 is-pulled-right" v-if="!isAffiliate">
                    <button class="button is-info" v-if="isAdmin" @click="downloadExcel">
                        <span>Export</span>
                        <span class="icon is-small">
                           <i class="fas fa-file-excel"></i>
                        </span>
                    </button>
                    <router-link
                        tag="button"
                        to="create"
                        class="button is-success">
                        <span>Create</span>
                        <span class="icon is-small">
                          <i class="fas fa-user-plus"></i>
                        </span>
                    </router-link>
                </div>
            </div>
        </div>
        <div class="columns">
            <div class="column">
                <div class="field">
                    <p class="control search-field is-expanded has-icons-left is-fullwidth">
                        <input class="input" type="text" v-model="search" v-on:keyup="searchFormChange" placeholder="User name, email or id">
                        <span class="icon is-small is-left">
                      <i class="fas fa-search"></i>
                    </span>
                    </p>
                </div>
            </div>
        </div>

        <div class="columns">
            <div class="column">
                <app-table></app-table>
            </div>
        </div>
    </div>
</template>

<script>
    import UsersTable from './UsersTable'
    import apiUsers from '../../api/apiUsers'
    export default {
        components: {
            appTable: UsersTable
        },
        computed: {
            search:{
                get: function () {
                    return this.$store.getters.getUsersQuerySearch
                },
                set: function (value) {
                    this.$store.dispatch('setUsersSearchQuery', value)
                }
            },
            isAdmin() {
                if (this.$store.getters.getUserRole === 'Admin') {
                    return true
                }
            },
            isAffiliate() {
                if (this.$store.getters.getUserRole === 'Affiliate') {
                    return true
                }
            }
        },
        methods: {
            downloadExcel () {
                apiUsers
                    .usersExportInExcelRequest()
                    .then((response) => {
                        const url = window.URL.createObjectURL(new Blob([response.data]))
                        const link = document.createElement('a')
                        link.href = url
                        link.setAttribute('download', 'users.xlsx')
                        document.body.appendChild(link)
                        link.click()
                    })
                    .catch((error) => {
                        console.log(error)
                    })
            },
            searchFormChange(){
                this.$store.dispatch('fetchUsersWithSearchQuery')
                this.$store.dispatch('setUsersCurrentPageToDefault')
            }
        }
    }
</script>

<style scoped>
    .container {
        margin-top: 25px;
    }
</style>



// WEBPACK FOOTER //
// src/components/Users/UsersList.vue